const options = {
    name: 'Navigation Language',
    children: []
};

export const formatLanguageOptions = (languages) => {
    if (!languages) {
        return options;
    }

    options.children = languages.map((item) => {
        const child = {
            childrenCount: 0,
            configProperties: null,
            cssClass: null,
            id: item.id,
            name: item.title,
            navigationUrl: item.url,
            productCount: 0,
            type: 'link',
            url: item.url
        };
        return child;
    });

    return options;
};
